export default __webpack_public_path__ + "static/media/app_gallery.0bb7e738.png";